export const cssProperties = {
  drawerWidth: 85,
  headerHight: 80,
  fontcolor: {
    primary: "rgba(33, 33, 33, 1)",
    tableblack: "rgba(26, 26, 26, 1)",
  },
  backgroundcolor: {
    // primary: 'rgba(247, 247, 247, 1)',
    // secondary: 'rgba(255, 255, 255, 1)',
    // secondary2:'rgb(230,151,171)',
    // secondary3:'rgb(232,173,190)'

    /* --- MHCET V3 --- */
    primary: "rgba(15, 79, 150, 1)", //#0F4F96
    primary2:"rgba(254, 254, 254, 1)", //#FEFEFEFE
    primary3:"rgba(14, 79, 150, 0.14)",//#0E4F9624
    secondary: "rgba(243, 246, 250, 1)", //#F3F6FA
    footer: "rgba(246, 248, 251, 1)", //#F6F8FB
    quaternary: "rgba(236, 236, 236, 1)", //#ECECEC
    white:"rgba(255, 255, 255, 1)", //#ffffff
    black:"rgba(0, 0, 0, 1)", //#ffffff
  },
  bordercolor: {
    // primary: 'rgba(163, 163, 163, 1)', //#A3A3A3
    // secondary: 'rgba(218, 218, 218, 1)',
    // secondary3: 'rgba(189, 189, 189, 1)',
    // primary2blue: 'rgba(75, 77, 212, 1)',
    // primary4blue: 'rgba(207, 213, 241, 1)'

    /* --- MHCET V3 --- */
    primary: "rgba(15, 79, 150, 1)", //#0F4F96
    secondary : "rgba(51, 172, 192, 1)", //#33ACC0
    secondary2:"rgba(189, 216, 254, 1)", //#BDD8FE
    tertiary : "rgba(236, 236, 236, 1)", //#ECECEC
    white:"rgba(255, 255, 255, 1)", //#ffffff
    black:"rgba(0, 0, 0, 1)", //#000000
  },
  color: {
    // primary: 'rgba(63, 65, 209, 1)',
    gray: "rgba(163, 163, 163, 1)",
    neutralgrey: "rgba(51, 65, 85, 1)",
    textsecondary: "rgba(102, 102, 102, 1)", //#666666
    textsecondary2: "rgb(230,151,171)",
    failure: "rgba(230, 57, 63, 1)", //#e6393f
    

    /* --- MHCET V3 --- */
    primary: "rgba(15, 79, 150, 1)", //#0F4F96
    primary2: "rgba(86, 131, 181, 1)", //background: #5683B5;
    secondary: "rgba(243, 246, 250, 1)", //#F3F6FA
    secondary2:"rgba(82, 78, 78, 1)", //#524E4E
    tertiary: "rgba(80, 78, 80, 1)", //#504E50
    white:"rgba(255, 255, 255, 1)", //#ffffff
    black:"rgba(0, 0, 0, 1)", //#000000
    failure: "rgba(230, 57, 63, 1)", //#e6393f

  },
  // hoverfontcolor: {
  //   sidebar: "rgba(63, 65, 209, 1)",
  // },
  // hoverbgcolor: {
  //   sidebar: "rgba(225, 232, 245, 1)",
  // },
  buttonbgcolor: {
    primary: "rgba(230, 151, 171, 1)",
  },
  buttonfontcolor: {
    black: "rgba(49, 0, 0, 1)",
  },
  surface: {
    primary: "rgba(240, 242, 244, 1)", //#f0f2f4
  },
  /* --- MHCET V3 --- */
  hoverfontcolor: { sidebar: 'rgba(63, 65, 209, 1)', },
  hoverbgcolor: { sidebar: 'rgba(15, 79, 150, 1)', },
  spanstyle:{backgroundColor:'#fff',borderRadius:'50%',width:'30px',height:'30px'},
  iconstyle:{width:'23px',height:'23px',color:'green',marginTop:'3px'},
};
